import {useGetConfigApiMethod} from 'api/useGetConfigApiMethod'
import {useCallback} from 'react'
import {createRecaptchaToken} from './createRecaptchaToken'
import {getRecaptchaSiteKey} from './siteKey'
import {CreateRecaptchaToken, RecaptchaAction} from './types'

/**
 * Returns a just-in-time token generator for protected Checkout API requests.
 *
 * Deliberately not a React provider: `POST /orders` and `POST /bookings` are issued
 * from the CartItemBuilder and Cart apps, which have no `ConfigProvider`. The site key
 * is memoised at module scope instead, so any app under `EnvironmentProvider` can
 * generate a token without an extra provider or a blocking render.
 */
export const useRecaptchaToken = (): CreateRecaptchaToken => {
  const getConfig = useGetConfigApiMethod()

  return useCallback(
    async (action: RecaptchaAction) => {
      const siteKey = await getRecaptchaSiteKey(getConfig)

      return createRecaptchaToken(siteKey, action)
    },
    [getConfig]
  )
}
